module.exports = __webpack_public_path__ + "aea1544b17a78703d4d19b41bd7e9b69.png";